// removed by extract-text-webpack-plugin
module.exports = {"box":"_4jkp4yceeptfhd3k9n73j19j65fd5y1mzc1gn8mrr58ezpn7epv11z3xsp9mys3e9sw2s4r8td8131h1unfd5xg1uz9pzvwmbvs25k5-styles-module-box","checkbox":"_3ur4rf7chv933213nym1xc4xefsanewqefk9hr4ujuxgzm8nt5jz83pva7tw32qv5hhn5tue8peqeftjbrcdrbvz41w5r6gsqe8ee5-styles-module-checkbox","commentNew":"y2f6kjf9xmjjseawe9uyks5dx6921p9ed6wvzmdthaaj2b572udqxgkq5hpzutwrphwdv8xhm3dfzyufeg4gfg74e3jd5psdn6qw7n-styles-module-commentNew"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/CollectionCase/CollectionCaseComments/styles.module.sass
// module id = 471
// module chunks = 0